import ApiSDKError from './ApiSDKError'

export default class NoResponseError extends ApiSDKError {
    constructor() {
        super('No response received from API')
        Object.setPrototypeOf(this, new.target.prototype)
        this.name = 'NoResponseError'
    }
}
